import api from './axios';

const inventoryApi = {
  // Get all inventory items with filters
  getItems: (params) => {
    return api.get('/inventory', { params });
  },

  // Get single inventory item
  getItem: (id) => {
    return api.get(`/inventory/${id}`);
  },

  // Create new inventory item
  createItem: (data) => {
    return api.post('/inventory', data);
  },

  // Update inventory item
  updateItem: (id, data) => {
    return api.put(`/inventory/${id}`, data);
  },

  // Assign or reassign inventory
  assignItem: (data) => {
    return api.post('/inventory/assign', data);
  },

  // Delete inventory item
  deleteItem: (id) => {
    return api.delete(`/inventory/${id}`);
  },

  // Get movement history
  getItemHistory: (id) => {
    return api.get(`/inventory/${id}/history`);
  },

  // Get categories
  getCategories: () => {
    return api.get('/inventory/categories');
  },

  // Get low stock items
  getLowStockItems: () => {
    return api.get('/inventory/low-stock');
  },

  // Get item stock locations breakdown
  getItemStockLocations: (id) => {
    return api.get(`/inventory/${id}/stock-locations`);
  }
};

export default inventoryApi;
